'use client'

import Link from 'next/link'

import { Card, ContractPopover } from '@/entities/contract'
import { Nullable } from '@/shared/lib'
import { TextButton } from '@/shared/ui'

import { RefundTerm, type Props as RefundTermProps } from '../refund-term'
import {
  GuestPayInformationDetail,
  type Props as GuestPayInformationDetailProps,
} from './detail'
import { UpdateReceiptInformationButton } from '../receipt-info-dialog/show-dialog-button'

export type Props = GuestPayInformationDetailProps &
  Nullable<Pick<RefundTermProps, 'refundTerms'>> & {
    isOldRefundTerms: boolean
    hasReceiptInfo: boolean
    isReceiptInformationButtonVisible: boolean
    isPaymentStatementButtonVisible: boolean
    contractId?: number
  }

export const GuestPayInformation = ({
  contractId,
  hasReceiptInfo,
  isReceiptInformationButtonVisible,
  isPaymentStatementButtonVisible,
  refundTerms,
  isOldRefundTerms,
  ...restProps
}: Props) => {
  const showReceiptTooltip = !hasReceiptInfo

  return (
    <Card.Root spacing="large">
      <Card.Item>
        <Card.ItemTitle>결제금액</Card.ItemTitle>
        <Card.ItemContent className="space-y-6">
          {(() => {
            if (
              !(
                isPaymentStatementButtonVisible ||
                isReceiptInformationButtonVisible
              )
            ) {
              return null
            }

            return (
              <div className="flex gap-6">
                {isPaymentStatementButtonVisible && (
                  <TextButton size="small" weight="normal" underline asChild>
                    <Link href={`/guest/contract/${contractId}/bill`}>
                      결제내역서
                    </Link>
                  </TextButton>
                )}
                {isReceiptInformationButtonVisible && (
                  <ContractPopover
                    defaultOpen={showReceiptTooltip}
                    message="영수증 발급 정보를 입력해 주세요"
                    side="top"
                  >
                    <UpdateReceiptInformationButton underline>
                      영수증 발급
                    </UpdateReceiptInformationButton>
                  </ContractPopover>
                )}
              </div>
            )
          })()}
          <GuestPayInformationDetail {...restProps} />
          {refundTerms && (
            <RefundTerm
              refundTerms={refundTerms}
              isOldRefundTerms={isOldRefundTerms}
            />
          )}
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
